import PlayerSeedingTable from "../../players/tables/PlayerSeedingTable";
import {useTranslation} from "react-i18next";
import {formatDate} from "../../../util/StringUtils";
import {FREE_WIN_PLAYER_ID} from "../../../util/Constants";
import {GenericInput} from "../../common/GenericInput";
import type {ReactNode} from "react";
import type {TournamentDetail, Match, PlayerWithSeeding} from "../../../types/domain";

interface InformationTabProps {
    tournament: TournamentDetail;
}

function InformationTab(props: InformationTabProps) {
    const { t } = useTranslation();

    const getTournamentInformationRow = (fieldName: string, fieldValue: ReactNode) => {
        return (
            <div className="tournament-info-item">
                <div className="tournament-info-field-name">{fieldName}:</div>
                <div className="tournament-info-field-value">{fieldValue}</div>
            </div>
        );
    }

    let averageElo: number | string = "?";
    const playerElosMap = new Map<number, number>();
    props.tournament.players.forEach((player: PlayerWithSeeding) => {
        if (player.player.elo != null) {
            playerElosMap.set(player.player.id, player.player.elo);
        }
    })
    if (props.tournament.rounds.length > 0) {
        const sortedMatches = [...props.tournament.rounds[0].matches].sort((a: Match, b: Match) =>
            (a.finishedAt ?? "") < (b.finishedAt ?? "") ? 1 : -1)
        sortedMatches.forEach((match: Match) => {
            if (match.playerOneEloBeforeMatchFinished && match.playerTwoEloBeforeMatchFinished) {
                playerElosMap.set(match.playerOne.id, match.playerOneEloBeforeMatchFinished)
                playerElosMap.set(match.playerTwo.id, match.playerTwoEloBeforeMatchFinished)
            }
        });
        playerElosMap.delete(FREE_WIN_PLAYER_ID)
    }
    const playerElos = Array.from(playerElosMap.values());
    if (playerElos.length > 0) {
        averageElo = playerElos.reduce((acc, elo) => acc + elo, 0) / playerElos.length;
    }

    return (
        <>
            <div className="left-half-responsive">
                <div className="mt-3 mb-3">
                    <h3>{t("information")}</h3>
                </div>
                {getTournamentInformationRow(t("tournamentName"), props.tournament.name)}
                {getTournamentInformationRow(t("tournamentDate"), formatDate(props.tournament.createdAt))}
                {getTournamentInformationRow(t("tournamentSystem"), t("tournamentSystem_" + props.tournament.type))}
                {getTournamentInformationRow(t("organizer"), props.tournament.organizer)}
                {getTournamentInformationRow(t("setsNeededToWin"), props.tournament.setsNeededToWin)}
                {getTournamentInformationRow(t("averageElo"), typeof averageElo === "number" ? Math.round(averageElo) : averageElo)}
                <div className="mt-3 ms-2">
                    <GenericInput id={"tournament-information-tab-note-" + props.tournament.id} as="textarea"  />
                </div>
            </div>
            <div className="right-half-responsive">
                <div className="mt-3 mb-3">
                    <h3>{t("seeding")}</h3>
                </div>
                <PlayerSeedingTable players={props.tournament.players.map(it => it.player)} isEditable={false} />
            </div>
        </>
    );
}

export default InformationTab
